export enum CurrencySymbol {
    USD = '$',
    CAD = 'C$',
    AUD = 'A$',
    EUR = '€',
}
